import Layout from '@/layout/layout'

const systemManageRouter = {
  path: '/systemManage',
  component: Layout,
  redirect: 'noRedirect',
  name: '系统管理',
  children: [
    {
      path: 'RolePurview',
      component: () => import('@/views/systemManage/RolePurview/index'),
      name: '角色权限',
      meta: { title: '角色权限', noCache: true }
    },
    {
      path:'StaffManage',
      component: () => import('@/views/systemManage/StaffManage/index'),
      name: '职员管理',
      meta: { title: '职员管理', noCache: true }
    },
    {
      path:'RoleAdd',
      component: () => import('@/views/systemManage/add/RoleAdd'),
      name: '编辑角色',
      meta: { title: '编辑角色', noCache: true }
    },  {
      path:'Functionconfiguration',
      component: () => import('@/views/systemManage/Functionconfiguration/index'),
      name: '功能配置',
      meta: { title: '功能配置', noCache: true }
    },
    {
      path:'log',
      component: () => import('@/views/systemManage/log/index'),
      name: '操作日志',
      meta: { title: '操作日志', noCache: true }
    },
  ]
}

export default systemManageRouter
